import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicantService, SpinnerData } from '../applicant.service';
import { Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { environment as ENV } from '../../environments/environment';
import { EncryptionService } from '../encryption.service';

@Component({
  selector: 'wl-si-consent',
  templateUrl: './si-mail-consent.component.html',
  styles: [],
  providers: [ApplicantService]
})
export class SiMailConsentComponent implements OnInit {

  token = '';
  type = '';
  mobileNumber = '';
  win: Window;
  verified: boolean;
  progressBar: boolean;
  linkExpired: boolean;
  data: any;

  logo: any;

  sidenavWidth: string = "88";
  sideNavMargin: string = "210";
  selectedMenuItem = '';
  isMenuOpen: boolean = true;
  isMobile = false;
  private breakpointSubscription: Subscription;
  showSpinner: boolean;
  showSpinnerWithMessage: boolean;
  subText: string;
  loading: any;

  constructor(private applicant: ApplicantService,
    private route: ActivatedRoute,
    private snackbar: MatSnackBar,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
  private encryptionService: EncryptionService) {
    // Detect changes in screen size and adjust sidenav mode accordingly
    this.breakpointSubscription = this.breakpointObserver
      .observe([Breakpoints.Small, Breakpoints.XSmall])
      .subscribe((state) => {
        console.log(state)
        this.isMobile = state.matches;
        if (this.isMobile) {
          this.sidenavWidth = "98";
          this.isMenuOpen = false;
        }


      });


  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.mobileNumber = params['id'];
      this.token = params['token'];
      this.type = params['type'];
    });

    this.logo = ENV.logo;

    sessionStorage.setItem("mobileNumber",this.mobileNumber);

    this.applicant.stringSubject.subscribe((spinnerData: SpinnerData) => {
      console.log(spinnerData)
      this.showSpinner = (spinnerData['showSpinner']);
      this.showSpinnerWithMessage = spinnerData['spinnerWithMessage'];
      this.subText = spinnerData['subText'];
    })

    sessionStorage.setItem("backendPublicKey","MCowBQYDK2VuAyEAgN+Y9OCr1K40SZIUpBJ6/Y0V5yZYgMBT0Fh5ZgMbvxs=");
    this.encryptionService.initiateEncryption();

    this.progressBar = true;
    this.showSpinner = true;
    // this.applicant.submitEntityConsent({ token: this.token, mobileNumber: this.mobileNumber }).subscribe((submitResult) => {
    //   this.showSpinner = false;
    //   if (submitResult) {
    //     if (submitResult.success == true && submitResult.isVerified) {
    //       this.snackbar.open("Your data has been recorded. Thank you!", 'OK', { duration: 2000 });
    //       this.verified = true;
    //       this.progressBar = false;
    //       this.linkExpired = false;
    //     } else {
    //       this.verified = false;
    //       this.progressBar = false;
    //       this.linkExpired = true;
    //       this.snackbar.open("Link has expired. Please generate again", 'OK', { duration: 2000 });
    //     }
    //   } else {
    //     this.verified = false;
    //     this.progressBar = false;
    //     this.snackbar.open("Verification failed. Please contact the  Admin", 'OK', { duration: 2000 });
    //   }
    // }, (err) => {
    //   this.showSpinner = false;
    //   this.snackbar.open("Verification failed. Please contact the  Admin", 'OK', { duration: 2000 });
    // });


    this.applicant.verifySiEmailOtp({ token: this.token }).subscribe((submitResult) => {
      this.showSpinner = false;
      if (submitResult) {
        if (submitResult.success == true && submitResult.isVerified) {
          this.snackbar.open("Your data has been recorded. Thank you!", 'OK', { duration: 2000 });
          this.verified = true;
          this.progressBar = false;
          this.linkExpired = false;
        } else {
          this.verified = false;
          this.progressBar = false;
          this.linkExpired = true;
          this.snackbar.open("Link has expired. Please generate again", 'OK', { duration: 2000 });
        }
      } else {
        this.verified = false;
        this.progressBar = false;
        this.snackbar.open("Verification failed. Please contact the  Admin", 'OK', { duration: 2000 });
      }
    }, (err) => {
      this.showSpinner = false;
      this.snackbar.open("Verification failed. Please contact the  Admin", 'OK', { duration: 2000 });
    });

  }

  submitConsent() {

  }

}
